var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#1E95F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11043 8.85539C5.7199 8.46487 5.08674 8.46487 4.69621 8.85539C4.30569 9.24592 4.30569 9.87908 4.69621 10.2696L6.11043 8.85539ZM15.3028 8.14829C15.6933 7.75776 15.6933 7.1246 15.3028 6.73407C14.9123 6.34355 14.2791 6.34355 13.8886 6.73407L15.3028 8.14829ZM8.93885 13.098L8.23175 13.8051L8.93885 14.5122L9.64596 13.8051L8.93885 13.098ZM13.8886 6.73407L8.23175 12.3909L9.64596 13.8051L15.3028 8.14829L13.8886 6.73407ZM9.64596 12.3909L6.11043 8.85539L4.69621 10.2696L8.23175 13.8051L9.64596 12.3909Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.70419bd1.svg";
export { ForwardRef as ReactComponent };